import { memo } from 'react';

import { AssetModalHeaderSeparator } from '~/components/AssetModalV2/Header/components/AssetModalHeaderSeparator';
import { CloseButton } from '~/components/AssetModalV2/Header/components/CloseButton';
import { Header } from '~/components/AssetModalV2/Header/components/Header';
import { PublicAssetNavigationArrows } from '~/components/AssetModalV2/Header/PublicAssetComponents/PublicAssetNavigationArrows';
import { PublicOptionsMenu } from '~/components/AssetModalV2/Header/PublicAssetComponents/PublicOptionsMenu';
import { PublicShowcaseAssetBreadcrumbs } from '~/components/AssetModalV2/Header/PublicShowcaseAssetComponents/PublicShowcaseAssetBreadcrumbs';
import { ShowcaseAssetShareButton } from '~/components/AssetModalV2/Header/PublicShowcaseAssetComponents/ShowcaseAssetShareButton';
import {
  type UseClosePublicAssetModalProps,
  useClosePublicAssetModal,
} from '~/components/AssetModalV2/hooks/useClosePublicAssetModal';

export type PublicShowcaseAssetHeaderProps = Pick<UseClosePublicAssetModalProps, 'onCloseAssetModal'>;

export const PublicShowcaseAssetHeader = memo(({ onCloseAssetModal }: PublicShowcaseAssetHeaderProps) => {
  const { closeAssetModal } = useClosePublicAssetModal({ onCloseAssetModal, trackLocation: 'close-button' });

  return (
    <Header
      headerLeft={
        <div className="flex items-center gap-2">
          <PublicShowcaseAssetBreadcrumbs />
        </div>
      }
      headerRight={
        <div className="flex items-center gap-4">
          <PublicOptionsMenu />
          <ShowcaseAssetShareButton />
          <PublicAssetNavigationArrows />
          <AssetModalHeaderSeparator />
          <CloseButton onClose={closeAssetModal} />
        </div>
      }
    />
  );
});

PublicShowcaseAssetHeader.displayName = 'PublicShowcaseAssetHeader';
